import React from "react";
import "./style.css";
import NotFoundImg from './404.svg';
import { Button, Icon } from 'antd';
import {withRouter} from "react-router-dom";
import { history } from '../../container/History';

class NotFound extends React.Component {
  handleClick = () => {
    history.push("/Dashboard");
  }

  render() {
    return (
    <div className="NotFound">
      <img src={NotFoundImg} className="NotFoundImg" />
    </div>
    )
  }
}

export default withRouter(NotFound);


// WEBPACK FOOTER //
// ./src/components/NotFound/index.js